// This icon file is generated automatically.
var PMailOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.5 1.5H.5A.5.5 0 000 2v10c0 .28.22.5.5.5h13a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5zm-.63 1.73v8.15H1.13V3.22L.69 2.9l.62-.8.67.53h10.04l.67-.52.62.79-.44.33zm-.84-.6L7 6.53l-5.03-3.9-.66-.53-.62.8.43.33 5.34 4.15c.32.25.76.25 1.07 0l5.34-4.15.44-.33-.62-.8-.66.52z", "fill-rule": "nonzero" } }] }, "name": "p-mail", "theme": "outlined" };
export default PMailOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PMailOutlined.js
// module id = 3498
// module chunks = 0